import { render } from "./DigitalPreprint.vue?vue&type=template&id=4b92ab02&scoped=true"
import script from "./DigitalPreprint.vue?vue&type=script&lang=js"
export * from "./DigitalPreprint.vue?vue&type=script&lang=js"

import "./DigitalPreprint.vue?vue&type=style&index=0&id=4b92ab02&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b92ab02"]])

export default __exports__